import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Rotas onde o widget Mia NAO aparece (atrapalha a UI ou nao faz sentido).
// - /contents/new* — fluxo de criacao de novo projeto (wizard, instagram, manual)
// - /contents/batch/* — viewer e editores pos-geracao (atrapalha o toque)
const HIDDEN_ROUTES = [
  '/admin/lab/review',
  '/onboarding',
  '/contents/new',
  '/contents/batch',
];

const AIChatWidget = () => {
  const location = useLocation();
  const iframeRef = useRef(null);

  const isHidden = HIDDEN_ROUTES.some(route => location.pathname.startsWith(route));

  useEffect(() => {
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 768;

    const handleMessage = (event) => {
      const iframe = iframeRef.current;
      if (!iframe || !event.data || !event.data.type) return;

      switch (event.data.type) {
        case 'agent-chat-resize':
          iframe.style.width = event.data.width;
          iframe.style.height = event.data.height;
          iframe.style.bottom = event.data.bottom;
          iframe.style.right = event.data.right;
          iframe.style.borderRadius = event.data.borderRadius;

          if (isMobile && event.data.height === '100vh') {
            const setRealHeight = () => {
              if (!window.visualViewport) {
                iframe.style.height = window.innerHeight + 'px';
                iframe.style.top = '0px';
                return;
              }
              const viewport = window.visualViewport;
              iframe.style.height = viewport.height + 'px';
              iframe.style.top = (viewport.offsetTop || 0) + 'px';
            };
            setRealHeight();
            if (window.visualViewport) {
              window.visualViewport.addEventListener('resize', setRealHeight);
              window.visualViewport.addEventListener('scroll', setRealHeight);
            } else {
              window.addEventListener('resize', setRealHeight);
            }
          }
          break;

        case 'agent-chat-ready':
          iframe.contentWindow.postMessage(
            {
              type: 'parent-info',
              isMobile: isMobile,
              screenWidth: window.innerWidth,
            },
            '*'
          );
          break;

        case 'agent-chat-opened':
          break;

        case 'agent-chat-closed':
          break;

        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (isHidden) return null;

  return (
    <iframe
      ref={iframeRef}
      id="ai-chat-widget"
      src="https://www.infinitagents.com/agent-chat/iframe/3b5a8807-bd8b-4c11-a14b-caae0cdfac4d?apiKey=pawsf_150d411bb2350c6458598f2ea9adf866"
      title="Assistente Hello Social"
      style={{
        position: 'fixed',
        border: 'none',
        zIndex: 9999,
        bottom: '20px',
        right: '20px',
        transition: 'all .3s ease',
        overflow: 'hidden',
        pointerEvents: 'auto',
      }}
      frameBorder="0"
      allowTransparency="true"
    />
  );
};

export default AIChatWidget;
